import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDistributor, useAdmin, useSuperAdmin } from '../lib/auth';

export function RequireDistributor({ children }) {
    const { user, loading } = useDistributor();
    const loc = useLocation();
    if (loading) return <FullScreenLoader />;
    if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
    return children;
}

/**
 * Item 4 — any authed realm may view the public homepage / cart / checkout.
 * Distributor, Employee Admin, or Super Admin. The Header component adapts
 * its menu based on the effective role.
 */
export function RequireAnyAuth({ children }) {
    const { user, loading: dLoading } = useDistributor();
    const { admin, loading: aLoading } = useAdmin();
    const { superAdmin, loading: sLoading } = useSuperAdmin();
    const loc = useLocation();
    if (dLoading || aLoading || sLoading) return <FullScreenLoader />;
    if (user || admin || superAdmin) return children;
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
}

/** Returns 'super_admin' | 'admin' | 'distributor' | null — most-privileged wins. */
export function useCurrentRole() {
    const { user } = useDistributor() || {};
    const { admin } = useAdmin() || {};
    const { superAdmin } = useSuperAdmin() || {};
    if (superAdmin) return 'super_admin';
    if (admin) return 'admin';
    if (user) return 'distributor';
    return null;
}

export function RequireAdmin({ children }) {
    const { admin, loading } = useAdmin();
    if (loading) return <FullScreenLoader />;
    if (!admin) return <Navigate to="/admin" replace />;
    return children;
}

export function RequireSuperAdmin({ children }) {
    const { superAdmin, loading } = useSuperAdmin();
    if (loading) return <FullScreenLoader />;
    if (!superAdmin) return <Navigate to="/secure-admin-login" replace />;
    return children;
}

export function FullScreenLoader() {
    return (
        <div className="min-h-screen bg-sdf-ivory flex items-center justify-center">
            <div className="spinner" />
        </div>
    );
}
